import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface PageState {
  loadersCount: number;
}

export function createPageInitialState(): PageState {
  return {
    loadersCount: 0
  };
}

@StoreConfig({ name: 'page' })
@Injectable({ providedIn: 'root' })
export class PageStore extends Store<PageState> {
  constructor() {
    super(createPageInitialState());
  }
}
